import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProjectById } from "../../services/projectsService";
import '../../css/projectsdetail.css';
import { useAuth } from '../../context/AuthContext';

const ProjectDetail = () => {
    const { id } = useParams();
    const { userId } = useAuth(); // Get the logged-in user's ID
    const navigate = useNavigate();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProject = async () => {
            try {
                const data = await getProjectById(id);
                setProject(data);
            } catch (error) {
                console.error("Error fetching project:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProject();
    }, [id]);

    const renderStatus = (status) => {
        const colorMap = {
            ongoing: 'green',
            completed: 'gray',
            cancelled: 'red',
            pending: 'orange'
        };

        const color = colorMap[status?.toLowerCase()] || 'blue';

        return (
            <span
                className="project-status-tag"
            >
                {status}
            </span>
        );
    };

    const handleInquire = () => {
        alert('Inquire or Apply for the project'); // Future action on button click (could open a modal)
    };

    const handleMessage = () => {
        alert('Redirecting to message system'); // Future action to send message
    };

    const handleLike = () => {
        alert('Liked the project'); // Future action to toggle like
    };

    const handleFavorite = () => {
        alert('Project added to favorites'); // Future action to toggle favorite
    };

    const handleShare = () => {
        alert('Project shared'); // Future action to share project link
    };

    const renderProjectTree = () => {
        return (
            <div className="project-tree">
                <h3><i className="fa-brands fa-pagelines"></i> Project Tree</h3>
                <ul>
                    <li>
                        <strong>Manager:</strong> {project.profile.username}
                    </li>
                    {project.contributors && project.contributors.length > 0 && (
                        <>
                            <h4>Contributors:</h4>
                            <ul>
                                {project.contributors.map((contributor, idx) => (
                                    <li key={idx}>
                                        {contributor.username} - {contributor.role}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </ul>
            </div>
        );
    };

    if (loading) return <div className="project-detail-wrapper">Loading...</div>;
    if (!project) return <div className="project-detail-wrapper">Project not found</div>;

    return (
        <div className="project-detail-wrapper">
            <div className="project-detail-content">
                <div className="project-top-detail-section">
                    <div className="project-main-details">
                        <div className="project-title-row">
                            <h2 className="project-detail-title">{project.title}</h2>
                            <p className="project-page-info">
                                <strong>Budget:</strong> <i className="fas fa-dollar-sign money-icon"></i> {project.budget}
                                <span className="separator">|</span>
                                <i className="fas fa-location-dot location-icon"></i> <strong>Location:</strong> {project.location}
                                <span className="separator">|</span>
                                <strong>Status:</strong> {renderStatus(project.status)}
                            </p>
                        </div>
                        <div className="project-detail-buttons-row">
                            <div className="project-detail-buttons">
                                <button className="project-button inquire" onClick={handleInquire}><i className="fa-solid fa-hand"></i> Contribute</button>
                                <button className="project-button message" onClick={handleMessage}><i className="fa-solid fa-envelope"></i> Message</button>
                                <button className="project-button share" onClick={handleShare}>
                                    <i className="fa-solid fa-share"></i>
                                </button>
                            </div>
                            <div className="project-reactions">
                                <div className="reaction-item">
                                    <i className="fa-regular fa-thumbs-up"></i>
                                    <span className="reaction-count">0</span>
                                </div>
                                <div className="reaction-item">
                                    <i className="fa-regular fa-comment"></i>
                                    <span className="reaction-count">0</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="project-heart-container">
                        <i className="fa-regular fa-heart"></i>
                    </div>
                </div>

                {project.images[0]?.image_600x400 && project.images.length > 0 && (
                    <div className="project-detail-section project-images">
                        {project.images.map((imgObj, idx) => (
                            <img
                                key={idx}
                                src={imgObj.image_600x400}
                                alt={`Project image ${idx + 1}`}
                                className="project-image"
                            />
                        ))}
                    </div>
                )}

                <div className="project-detail-section">
                    <p>{project.description}</p>
                </div>

                {renderProjectTree()}
            </div>

            <div className="project-detail-side-info">
                <div className="project-profile-section poster-info">
                    <strong>Managed by:</strong>
                    <br />
                    <img
                        src={project.profile.photo_150_url || '/servspace-default.png'}
                        alt="Manager profile"
                        className="poster-profile-photo"
                        onClick={() => navigate(`/home/profile/${project.profile.user_id}`)}
                        style={{ cursor: 'pointer' }}
                    />
                    <div className="poster-details">
                        <h2>{project.profile.username || 'Anonymous'}</h2>
                        <p className="poster-bio">Project lead with 10 years experience in design & construction.</p>
                    </div>
                    <hr className="project-section-separator"></hr>
                    <div className="project-meta">
                        <div className="project-meta">
                            <div className="project-meta-item">
                                <i className="fa-solid fa-person"></i>
                                <span>
                                    {project.contributors?.length === 1
                                        ? '1 Person involved'
                                        : `${project.contributors?.length || 0} People involved`}
                                </span>
                            </div>
                        </div>
                    </div>
                    <p><strong>Start Date:</strong> {project.start_date}</p>
                    <p><strong>End Date:</strong> {project.end_date}</p>
                    <p><strong>Created:</strong> {project.created_at}</p>
                    <p><strong>Last Updated:</strong> {project.updated_at}</p>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetail;